"use client"

/**
 * Client half of the Conversions API handshake.
 *
 * newSignupEventId() is called once per signup, BEFORE the pixel fires, and the
 * same value goes to both fbq and the server. That shared id is the only thing
 * stopping Meta from counting one signup twice.
 *
 * reportSignupToMeta() must run AFTER sign-in: the route reads the session to
 * decide whose email to hash, and the password flows deliberately fire the
 * pixel before signInWithPassword.
 */
export function newSignupEventId(): string {
  try {
    return crypto.randomUUID()
  } catch {
    // Pre-2021 Safari, and any non-secure context. Collisions here would mean
    // a mis-deduplicated conversion, not a broken signup.
    return `booth-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
  }
}

/** Fire-and-forget; keepalive so it survives the post-signup redirect. */
export function reportSignupToMeta(eventId: string): void {
  try {
    void fetch("/api/meta/capi/signup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId }),
      keepalive: true,
    }).catch(() => {})
  } catch {
    // Never surfaces to the user.
  }
}
